import moment from 'moment'

export default {
  data() {
    return {
      // Component initialized
      loading: false,
      loadingLeaves: false,
      currentMonth: moment(),
      selectedMonth: moment().month(),
      selectedYear: moment().year(),
      weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      
      // ============================================
      // NEW CONSOLIDATED API DATA PROPERTIES
      // ============================================
      // Main dashboard data from getDashboardData() API
      dashboardData: {
        kpi_stats: {
          leave_balance: 0,
          leaves_taken: 0,
          approval_pending: 0,
          regularization_count: 0,
          wfh_count: 0
        },
        leave_balance_breakdown: [],
        leave_balance_raw: null,
        calendar_data: [],
        chart_data: {},
        config: {},
        holidays: [],
        announcements: [],
        birthdays: [],
        work_anniversaries: [],
        leaves: [],
        regularization_cases: []
      },
      // Team dashboard data from getTeamDashboard() API  
      teamDashboardData: null,
      // Real-time leave validation result from validateLeave() API
      validationResult: null,
      // Attendance/Leave configuration from getAttendanceConfig() API
      attendanceConfig: null,
      // ============================================
      
      // Legacy properties - kept for backward compatibility during migration
      leaveStats: {
        leaveBalance: 0,
        leavesTaken: 0,
        WFHCount: 0,
      },
      teamStats: {
        totalLeavesAvailed: 0,
        totalWFHCount: 0,
        totalRegularization: 0,
        membersOnLeave: 0,
      },
      myLeaves: [],
      biometricData: [],
      attendanceData: [],
      /** Today's punch rows for scoped team (Team View Present/Absent KPIs) */
      teamTodayPunchRecords: [],
      holidays: [],
      regularizationCases: [],
      recentlySubmittedRegularizations: new Map(), // Track recently submitted regularizations: key = "empId:date", value = { id, status, timestamp }
      abortController: null, // For cancelling pending requests
      // Date formatting cache - initialize as null, will be set in mounted
      _dateFormatCache: null,
      // Calendar optimization cache
      _disabledDatesSet: null,
      _holidayDatesSet: null,
      _calendarCacheKey: null,
      _calendarCache: false,
      announcements: [],
      birthdays: [],
      workAnniversaries: [],
      showCreateAnnouncementModal: false,
      announcementForm: {
        title: '',
        message: '',
        date: '',
      },
      creatingAnnouncement: false,
      showCreateHolidayModal: false,
      holidayForm: {
        holiday: '',
        date: '',
        location: null,
        year: null,
      },
      locationOptions: [
        { value: 'both', text: 'Both (Pune & Delhi)' },
        { value: 'pune', text: 'Pune Only' },
        { value: 'delhi', text: 'Delhi Only' },
      ],
      creatingHoliday: false,
      currentHolidayIndex: 0, // Index of currently displayed holiday
      // Company-Wide WFH Day — mirrors the Holiday state above exactly.
      // See attendance-service.js#getCompanyWfhDays/createCompanyWfhDay for
      // the backend-gap -> localStorage fallback this list is loaded from.
      companyWfhDays: [],
      showCreateCompanyWfhDayModal: false,
      companyWfhDayForm: {
        title: '',
        date: '',
        location: null,
      },
      creatingCompanyWfhDay: false,
      currentCompanyWfhDayIndex: 0, // Index of currently displayed company WFH day
        displayedLeavesLimit: 12, // Initial number of leaves to display
        displayedUpcomingLeavesLimit: 5, // Initial number of upcoming leaves to display
      // Celebration download date-range modal
      showCelebrationDownloadModal: false,
      celebrationDownloadFrom: null,   // 'YYYY-MM-DD'
      celebrationDownloadTo: null,     // 'YYYY-MM-DD'
      celebrationActivePreset: null,   // tracks which quick-preset is selected
      celebrationPresets: [
        { value: 'thisMonth',   label: 'This Month' },
        { value: 'nextMonth',   label: 'Next Month' },
        { value: 'thisQuarter', label: 'This Quarter' },
        { value: 'thisYear',    label: 'Full Year' },
      ],

      // Punch In/Out data download date-range modal
      showPunchDataDownloadModal: false,
      punchDownloadFrom: '',
      punchDownloadTo: '',
      punchDownloadActivePreset: null,
      punchDownloadLoading: false,
      punchDownloadEmployeeFilter: null,
      punchDownloadPresets: [
        { label: 'This Week',     value: 'week' },
        { label: 'This Month',    value: 'month' },
        { label: 'Last Month',    value: 'lastMonth' },
        { label: 'This Quarter',  value: 'quarter' },
      ],

      /** Probation rows for team members (HR source for People on Probation / ending-soon) */
      probationData: [],
      /** True after loadProbationData when no user/probation-API rows exist for the team */
      probationSourceMissing: false,

      /**
       * Applied punch filters from Team snapshot → Today's attendance roster.
       * Employee only (date range is for CSV download, not roster time bounds).
       */
      teamPunchRosterFilter: {
        empId: null,
        active: false,
      },

      // Date Range Filter
      dateRangeFilter: null, // Selected date range for filtering [startDate, endDate]
      dateRangeFilterTemp: null, // Temporary date range while selecting (kept for backward compatibility)
      fromDateFilterTemp: null, // Temporary from date in filter modal
      toDateFilterTemp: null, // Temporary to date in filter modal
      showDateRangePicker: false,
      dateRangeFilterDebounceTimer: null, // Timer for debouncing date range changes
      // Regularization Table Filters
      regularizationSourceTypeFilter: 'all', // Options: 'all', 'regularization', 'leave'
      regularizationDateFilter: null, // Date range for regularization table [startDate, endDate]
      regularizationLeaveTypeFilter: null, // Leave type filter (null = all)
      showRegularizationFilterModal: false, // Modal for regularization filters
      regularizationSourceTypeFilterTemp: 'all', // Temporary filter value in modal
      regularizationFromDateFilterTemp: null, // Temporary from date in regularization filter modal
      regularizationToDateFilterTemp: null, // Temporary to date in regularization filter modal
      regularizationLeaveTypeFilterTemp: null, // Temporary leave type filter in modal
      regularizationEmployeeFilter: null, // Filter by employee (emp_id) in team/org view
      regularizationEmployeeFilterTemp: null, // Temporary value in modal
      activeFilters: null, // Store active filters for API calls
      activeSourceTypeFilter: 'all', // Store active source type filter
      // Regularization Table View More/Less
      displayedRegularizationCount: 20, // Number of items currently displayed (increments by 20 on each "View More" click)
      regularizationDisplayLimit: 20, // Number of items to load per "View More" click
      displayedLeavesCount: 20, // Number of leaves currently displayed (increments by 20 on each "View More" click)
      leavesRegularizationActiveTab: 0, // Active tab index: 0 = Leaves, 1 = Regularization
      // Filter Modal
      showFilterModal: false,
      viewModeTemp: 'my', // Temporary value for filter modal
      selectedAccountManagerTemp: null, // Temporary value for filter modal
      selectedTeamWiseEmployeeTemp: null, // Temporary value for filter modal
      selectedTeamMemberTemp: null, // Temporary value for filter modal
      managerAbsent: false,
      managerInfo: null,
      alternateApprover: null,
      selectedRegularizationItem: null,
      selectedRegularizationForApproval: null,
      regularizationApprovalComment: '',
      isOnProbation: false,
      employeeConfig: null,
      apiLeaveTypeOptions: [],
      // Team View Management
      viewMode: 'my', // 'my', 'team', or 'team-wise'
      viewModeOptions: [],
      teamMembers: [],
      selectedTeamMember: null,
      selectedEmployeeForLeaveConfig: null, // Store selected employee's config for leave form
      selectedEmployeeForLeaveStats: null, // Store selected employee's leave stats for leave form
      selectedEmployeeForLeaveLeaves: [], // Store selected employee's leaves for leave form
      currentViewEmpId: null, // The emp_id currently being viewed (self or team member)
      userRoleID: null, // Store roleID from userData
      currentUserDepartment: '', // From userData.department (localStorage) for department-based leave flow
      // Team Wise View Management
      accountManagers: [],
      selectedAccountManager: null,
      teamWiseEmployees: [],
      teamWiseEmployeesForModal: [], // Employees loaded for the filter modal
      selectedTeamWiseEmployee: null,
      teamWiseAnalytics: {
        totalEmployees: 0,
        totalLeaves: 0,
        totalWFH: 0,
        pendingApprovals: 0,
        regularizationCases: 0,
      },
      teamLeaveFilter: 'all', // Filter for team leaves: 'all', 'pending', 'approved', 'rejected'
      teamLeaveFilterOptions: [
        { value: 'all', text: 'All Leaves' },
        { value: 'pending', text: 'Pending Approval' },
        { value: 'approved', text: 'Approved' },
        { value: 'rejected', text: 'Rejected' },
      ],
      teamRegularizationFilter: 'all', // Filter for team regularizations: 'all', 'pending', 'approved', 'rejected'
      teamRegularizationFilterOptions: [
        { value: 'all', text: 'All Regularizations' },
        { value: 'pending', text: 'Pending Approval' },
        { value: 'approved', text: 'Approved' },
        { value: 'rejected', text: 'Rejected' },
      ],
      showApplyLeaveModal: false,
      leaveForm: {
        from_date: null,
        to_date: null,
        leave_type: null,
        is_half_day: false, // true if half day is selected, false for full day
        half_day_type: null, // '1st Half Day' or '2nd Half Day' (only when is_half_day is true)
        comment: '',
        apply_to: 'manager',
        selected_employee: null, // Employee to apply leave on behalf of (for team view)
      },
      unpaidLeaveAcknowledged: false, // Track if user acknowledged unpaid leave warning
      leaveDateRange: null,
      calendarMonth: moment().month(),
      calendarYear: moment().year(),
      wfhCalendarMonth: moment().month(),
      wfhCalendarYear: moment().year(),
      datePickerKey: 0,
      applyToOptions: [
        { value: 'manager', text: 'Manager' },
        { value: 'hr', text: 'HR' },
      ],
      wfhForm: {
        id: null, // Leave ID for editing
        date: null,
        comment: '',
        partial_wfh: false, // True when employee is already at office and switching mid-day
        is_half_day: false, // True for pre-planned half-day WFH (morning or afternoon)
        half_day_type: '1st Half Day', // '1st Half Day' or '2nd Half Day'
        selected_employee: null, // Employee to apply WFH on behalf of (for team view)
      },
      compOffCalendarMonth: moment().month(),
      compOffCalendarYear: moment().year(),
      compOffWorkCalendarMonth: moment().month(),
      compOffWorkCalendarYear: moment().year(),
      compOffForm: {
        id: null, // Leave ID for editing
        date: null, // Date when comp off will be taken
        comment: '',
        selected_employee: null, // Employee to apply Comp Off on behalf of (for team view)
      },
      showCompOffDateCalendar: false, // Show/hide comp off date calendar
      // CO Balance Request form (Step 1: Request balance credit)
      compOffBalanceRequestForm: {
        work_date: null, // Date when extra work was done
        comment: '',
        selected_employee: null,
      },
      compOffBalanceWorkCalendarMonth: moment().month(),
      compOffBalanceWorkCalendarYear: moment().year(),
      showCompOffBalanceWorkCalendar: false,
      compOffBalanceRequests: [], // List of CO balance requests
      loadingCompOffRequests: false,
      selectedCompOffRequest: null, // Currently selected CO balance request for detail view
      compOffRequestsFields: [
        { key: 'work_date', label: 'Work Date (Earned On)', sortable: true },
        { key: 'total_days', label: 'CO Days Requested', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'createdAt', label: 'Request Date', sortable: true, formatter: (v, k, item) => this.formatDate ? this.formatDate(item.created_at || item.createdAt) : (item.created_at || item.createdAt || '') },
        { key: 'actions', label: '', sortable: false },
      ],
      punchConfig: null, // Store punch config data
      currentQuarterWFHCount: 0, // WFH count for current quarter
      isPermanentWFH: false, // Flag for permanent WFH employees
      selectedEmployeeWFHCount: 0, // WFH count for selected employee (when applying on behalf)
      selectedEmployeeIsPermanentWFH: false, // Flag for selected employee's permanent WFH status
      regularizationForm: {
        intime: '',
        outtime: '',
        comment: '',
        leave_type: null,
      },
      // Leave types fetched from /api/leave-types (global list from database)
      leaveTypesFromDB: [],
      // Legacy hardcoded options - kept as fallback, will be replaced by API data
      leaveTypeOptions: [],
      leaveFields: [
        { key: 'leave_type', label: 'Leave Type' },
        { key: 'dates', label: 'Dates' },
        { key: 'status', label: 'Status' },
        { key: 'applied_date', label: 'Applied Date' },
        { key: 'actions', label: 'Actions' },
      ],
      allTeamLeaves: [], // Store all team members' leaves for Team View
      pendingRegularizations: [], // Store pending regularization requests for approval
      teamMemberLeaveBalances: [], // Store leave balances for team members
      teamMemberConfigs: [], // Store employee configs for team members (for breakdown calculation)
      // Table field definitions for alerts
      lowLeaveBalanceFields: [
        { key: 'employee', label: 'Employee', sortable: true },
        { key: 'leaveBalance', label: 'Available Balance', sortable: true },
        { key: 'leavesTaken', label: 'Leaves Taken', sortable: true },
        { key: 'assignedBalance', label: 'Assigned Balance', sortable: true }
      ],
      frequentRegularizationFields: [
        { key: 'employee', label: 'Employee', sortable: true },
        { key: 'count', label: 'Count', sortable: true }
      ],
      leaveConflictsFields: [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'count', label: 'Count', sortable: true },
        { key: 'employees', label: 'Employees', sortable: false }
      ],
      probationEndingFields: [
        { key: 'employee', label: 'Employee', sortable: true },
        { key: 'probationEndDate', label: 'End Date', sortable: true },
        { key: 'daysRemaining', label: 'Days Remaining', sortable: true }
      ],
      teamLeaveBalanceFields: [
        { key: 'employee', label: 'Employee', sortable: true },
        { key: 'leaveBalance', label: 'Leave Balance', sortable: true },
        { key: 'leavesApplied', label: 'Leaves Taken', sortable: true },
      ],
      sourceTypeOptions: [
        { value: 'all', text: 'All' },
        { value: 'regularization', text: 'Regularization' },
        { value: 'leave', text: 'Leave' },
      ],
      selectedRegularizationForRejection: null, // Store regularization selected for rejection
      regularizationRejectionReason: '', // Reason for rejecting regularization
      selectedLeaveForApproval: null, // Store leave selected for approval
      approvalComment: '', // Comment for approving leave
      approvalStatusToSet: 'Approved', // Status to set when approving
      approvalIsCompensatory: false, // Flag for compensatory leave
      approvalIsPaid: true, // For HR approving probation employees: mark as paid holiday
      leaveDetailIsPaid: true, // Same for approve-from-detail modal
      selectedLeaveForRejection: null, // Store leave selected for rejection
      rejectionComment: '', // Comment for rejecting leave
      selectedLeaveForDetail: null, // Store leave selected for detail view
      leaveDetailComment: '', // Comment for approve/reject from detail modal
      selectedLeaveTypeForList: null, // Store leave type selected from chart
      filteredLeavesForList: [], // Filtered leaves for the list modal
      leavesTakenListFields: [
        { key: 'employee_name', label: 'Employee Name', sortable: true },
        { key: 'from_date', label: 'From Date', sortable: true },
        { key: 'to_date', label: 'To Date', sortable: true },
        { key: 'leave_type', label: 'Leave Type', sortable: true },
        { key: 'total_days', label: 'Days', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
      // regularizationFields will be computed property
      emp_id: null,
      empcode: null,
      mgr_id: null,
      userRole: '',
      leaveBalanceChartOptions: {
        chart: {
          id: 'leave-balance-chart',
          type: 'bar',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          fontFamily: 'Inter, sans-serif',
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val.toFixed(0)
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            fontWeight: 600,
            colors: ['#fff'],
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '60%',
            endingShape: 'rounded',
            borderRadius: 8,
            dataLabels: {
              position: 'top',
            },
          },
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '13px',
          fontWeight: 500,
          markers: {
            width: 12,
            height: 12,
            radius: 6,
          },
        },
        grid: {
          row: {
            colors: ['#f8f9fa', 'transparent'],
            opacity: 0.3,
          },
          column: {
            colors: ['#f8f9fa', 'transparent'],
            opacity: 0.3,
          },
          padding: {
            top: 10,
            right: 16,
            bottom: 32,
            left: 0,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '12px',
              fontWeight: 500,
              colors: '#374151',
            },
            rotate: -35,
            rotateAlways: false,
            maxHeight: 56,
            offsetY: 0,
          },
          axisBorder: {
            show: true,
            color: '#e5e7eb',
          },
          axisTicks: {
            show: true,
            color: '#e5e7eb',
          },
        },
        yaxis: {
          title: {
            text: 'Number of Leaves',
            style: {
              fontSize: '13px',
              fontWeight: 600,
              color: '#495057',
            },
          },
          min: 0,
          max: undefined, // Will be dynamically calculated based on data
          labels: {
            style: {
              fontSize: '12px',
              colors: '#6c757d',
            },
            formatter: function(val) {
              return val.toFixed(0)
            },
          },
          grid: {
            borderColor: '#e9ecef',
            strokeDashArray: 3,
          },
        },
        tooltip: {
          theme: 'light',
          y: {
            formatter: function(val) {
              // Show one decimal place to display 0.5 for half days
              return val.toFixed(1) + ' leaves'
            },
          },
          style: {
            fontSize: '13px',
          },
        },
        colors: ['#4caf50', '#ff9800'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.3,
            gradientToColors: ['#66bb6a', '#ffb74d'],
            inverseColors: false,
            opacityFrom: 0.9,
            opacityTo: 0.8,
            stops: [0, 100],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['#fff'],
        },
      },
      leaveBalanceChartSeries: [
        {
          name: 'Leaves Remaining',
          data: [],
        },
        {
          name: 'Leaves Taken',
          data: [],
        },
      ],
    }
  },
}
